module.exports = __webpack_public_path__ + "img/f4-1-2.fb209af0.png";